function setTripTypes(state, tripTypes) {
	state.tripTypes = tripTypes;
}

export default { setTripTypes };